// extracted by mini-css-extract-plugin
export var subtitle = "_b8-2";
export var title = "_b8-0";
export var titleNoWrap = "_b8-1";